import React, { Component } from "react";
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import * as wActs from "../actions/website-actions";
import {Helmet} from "react-helmet";
import * as wConst from "../consts/website-consts";

class Pager extends Component {

  getTranslation(key) {
    return this.props.WebPage.Translations[key];
  }

  changePage(evt,pge) {
    if (window && !this.props.skipScroll) { window.ScrollTop() }
    if(typeof this.props.changePage == "function") {
      this.props.changePage(pge);
    }
    if(!wActs.isNullOrUndefined(this.props.updateBack)) {
      this.props.dispatch({type: wConst.ACTION_SET_LAST_PAGE, payload: window.location.href.split("?")[0] + "?page=" + pge});
    }
  }

  getBaseUrl() {
    let sUrl = "https://www.dummy.com" + this.props.WebPage.ServerParams.Path + this.props.WebPage.ServerParams.Query;
    if(typeof window !== "undefined") {
      sUrl = window.location.href;
    }
    return sUrl;
  }

  removeParameterFromUrl(url, parameter) {
    return url
      .replace(new RegExp('[?&]' + parameter + '=[^&#]*(#.*)?$'), '$1')
      .replace(new RegExp('([?&])' + parameter + '=[^&]*&'), '$1');
  }

  buildQuery(currentLoc,pge) { //ONLY filter/term/page Are Allow'd In Query's
    let fil = wActs.getParameterByName("filter",this.getBaseUrl(),"");
    let trm = wActs.getParameterByName("term",this.getBaseUrl(),"");
    let nLoc = currentLoc;
    nLoc += `?page=${pge}${trm !== "" ? "&term=" + encodeURIComponent(trm) : ""}${fil !== "" ? "&filter=" + encodeURIComponent(fil) : ""}`;
    return nLoc;
  }

  getPagePath(pge) {
    let currentLoc = "";
    if(pge == 1) { //Do Not Do Query On Page 1
      if(typeof document === "undefined") {
        return this.props.WebPage.ServerParams.Path;
      } else {
        return document.location.pathname;
      }
    }
    if(typeof document === "undefined") {
      currentLoc = this.props.WebPage.ServerParams.Path
    } else {
      currentLoc = `${document.location.pathname}`;
    }
    return this.buildQuery(currentLoc,pge); //Rebuild Query Removing All Nonsense...
  }

  getPageLocation(pge) {
    let currentLoc = "";
    if(pge == 1) { //Do Not Do Query On Page 1
      if(typeof document === "undefined") {
        return this.props.WebPage.Settings.Url + (this.props.WebPage.ServerParams.Path == "/" ? "" : this.props.WebPage.ServerParams.Path);
      } else {
        return document.location.href.split("?")[0];
      }
    }
    if(typeof document === "undefined") {
      currentLoc = this.props.WebPage.Settings.Url + this.props.WebPage.ServerParams.Path
    } else {
      currentLoc = `https://${document.location.hostname}${document.location.pathname}`;
    }
    return this.buildQuery(currentLoc,pge); //Rebuild Query Removing All Nonsense...
  }
  capWords(txt) {
    return txt.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });
  }

  getFilterTitle(nme) {
    let list = [];
    if(!wActs.isNullOrUndefined(this.props.WebPage.Menu)) {
      if(!wActs.isNullOrUndefined(this.props.WebPage.Menu.Filter[0])) {
        if(!wActs.isNullOrUndefined(this.props.WebPage.Menu.Filter[0].Menu)) {
          list = this.props.WebPage.Menu.Filter[0].Menu.filter((t) => {return !t.IsTop});
        }
      }
    }
    nme = wActs.replaceAll("-"," ",nme);
    nme = this.capWords(nme);
    nme = wActs.replaceAll(" ","",nme);
    nme = "Filter" + nme;
    if(nme === "FilterVerified") {nme = "Filter100PVerified"}
    if(typeof list !== "undefined") {
      if(list.filter((t)=> {return t.Name === nme}).length>0) {
        return list.filter((t)=> {return t.Name === nme})[0].Title;
      }
    }

    if(nme=="FilterOurnetwork") return this.getTranslation("page.advertise.ournetwork");
    if(nme=="FilterOther") return this.getTranslation("menu.other");

    return nme;
  }

  render() {
    let hasNext = true;
    let hasLast = true;

    let pges = [];
    let NextPage = parseInt(this.props.Page, 10)+1;
    let LastPage = parseInt(this.props.Page, 10)-1;
    if(NextPage > this.props.TotalPages) {hasNext = false; NextPage = 1; }
    if(LastPage <=0 ) { hasLast = false; LastPage = this.props.TotalPages; }
    let StartPage = this.props.Page;
    if(this.props.TotalPages - this.props.ShowPages < StartPage) {
      StartPage = this.props.TotalPages - this.props.ShowPages;
    }
    if(StartPage <= 0) { StartPage = 1; }
    let EndPage = StartPage + this.props.ShowPages;
    if(EndPage > this.props.TotalPages) {
      EndPage = this.props.TotalPages;
    }
    for(let x=StartPage; x<=EndPage; x++) {
      let pge = <Link to={this.getPagePath(x)} key={"pager"+x} onClick={(e)=>this.changePage(e,x)} title={"Page " + x}>{x}</Link>;
      if(x===this.props.Page) {
        pge = <a key={"pager"+x} className="active" title={"Page " + x}>{x}</a>;
      }
      pges.push(pge);
    }
    let currentLoc = "";
    if(typeof document === "undefined") {
      currentLoc = this.props.WebPage.Settings.Url + this.props.WebPage.ServerParams.Path + this.props.WebPage.ServerParams.Query;
    } else {
      currentLoc = `https://${document.location.hostname}${document.location.pathname}${document.location.search}`;
    }

    let filter = "";
    let filters = wActs.getParameterByName("filter",currentLoc,"");
    if(!wActs.isNullOrEmpty(filters)) {
      filters = filters.split(",");
      if(filters.length>0) {
        filter = this.getFilterTitle(filters[0]);
      }
    }


    let desc = this.props.WebPage.Page.Description;
    if(this.props.Page != 1) {
      desc = `${this.props.Page}-${this.props.TotalPages} (${this.props.Count}) ${this.props.WebPage.Page.Description}`;
    }
    if(!wActs.isNullOrEmpty(filter)) {
      desc = filter + " - " + desc;
    }



    return (
      <div className="pagination centered-content" style={{ clear: "both" }}>
        <Helmet>
          <meta name={"description"} content={desc}/>
          <meta property={"og:description"} content={desc}/>
          <meta name={"twitter:description"} content={desc}/>
          {hasLast &&
          <link rel="prev" href={this.getPageLocation(LastPage)} />
          }
          {hasNext &&
          <link rel="next" href={this.getPageLocation(NextPage)} />
          }
        </Helmet>
        {hasLast &&
        <Link rel={"prev"} to={this.getPagePath(LastPage)} key={"last"+LastPage} onClick={(e)=>this.changePage(e,LastPage)} title={"Page " + LastPage}><i className="fa fa-arrow-circle-left"></i></Link>
        }
        {pges}
        {hasNext &&
        <Link rel={"next"} to={this.getPagePath(NextPage)} key={"next"+NextPage} onClick={(e)=>this.changePage(e,NextPage)} title={"Page " + NextPage}><i className="fa fa-arrow-circle-right"></i></Link>
        }
      </div>
    );
  }

}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website
  };
}

export default connect(mapStateToProps)(Pager);
